import * as React from 'react'
import { adminService, itemService, homeService } from '../../../../services'
import { toast } from 'react-toastify'
import MarqueeBanner from './containers/MarqueeBanner'
import {
  Button,
  Divider,
  Grid,
  Header,
  Icon,
  Input,
  InputOnChangeData,
  Segment
} from 'semantic-ui-react'
import { InfoTab } from './components/InfoTab'
import { GameItemDeck } from '../../components'
import { common } from '../../../../utils/common'

type RollItemStoreAdminState = {
  isLoading: boolean,
  availableRollItems: IGameItem[],
  pickedRollItems: IGameItem[],
  userTopInfo: IUserTopInfo,
  userTopId: string,
}
export default class RollItemStoreAdmin extends React.Component {

  state: RollItemStoreAdminState = {
    isLoading: true,
    availableRollItems: [],
    pickedRollItems: [],
    userTopId: '',
    userTopInfo: {
      nickname: '',
      steamId: ''
    }
  }

  componentDidMount() {
    this.getAvailableItem()
  }

  getAvailableItem = async () => {
    try {
      this.setState({isLoading: true})
      const response = await itemService.getRollItems()
      this.setState({
        isLoading: false,
        availableRollItems: response,
        pickedRollItems: []
      })
    } catch (error) {
      toast.error(error.message)
    }
  }

  handlePickItem = (item: IGameItem) => {
    let {availableRollItems} = this.state
    const indexItem = availableRollItems.indexOf(item)
    if (indexItem >= 0) {
      let newStateItems = availableRollItems.filter((v, i) => i !== indexItem)
      let pickedRollItems = this.state.pickedRollItems.concat(item)
      this.setState({
        availableRollItems: newStateItems,
        pickedRollItems: pickedRollItems,
      })
    }
  }

  handleRemoveItem = (item: IGameItem) => {
    let items = this.state.pickedRollItems
    const index = items.indexOf(item)
    if (index >= 0) {
      this.setState({
          pickedRollItems: items.filter((v, i) => i !== index),
          availableRollItems: this.state.availableRollItems.concat(item)
        }
      )
    }
  }

  onClickBuyItem = () => {
    let {userTopInfo, pickedRollItems, userTopId} = this.state
    if (!pickedRollItems || pickedRollItems.length <= 0) {
      toast.error('Bạn chưa chọn item!')
      return
    }
    this.setState({
      isLoading: true,
      requestSuccess: false
    })
    const rollRequestInfo = {
      steamId: userTopInfo.steamId ? userTopInfo.steamId : userTopId,
      gameItems: pickedRollItems
    }
    adminService.adminRoll(rollRequestInfo)
      .then(rollResult => {
        this.setState({
          isLoading: false,
        })
        if (rollResult.success) {
          toast.success(`Roll thành công cho steamID: ${rollResult.steamId}!`)
        } else {
          toast.error(`Roll không thành công! ${rollResult.message}`)
        }
        this.getAvailableItem()
      })
      .catch(reason => {
        toast.error(reason.message)
        this.setState({
          isLoading: false,
        })
      })
    window.scrollTo(0, 0)
  }

  onChangeSteamId = (event: React.SyntheticEvent<HTMLInputElement>, data: InputOnChangeData) => {
    event.preventDefault()
    if (data.value) {
      this.setState({
        userTopInfo: {
          steamId: undefined,
          nickname: undefined
        }
      })
      homeService.getUserTopInfo(data.value)
        .then(result => {
          this.setState({
            userTopInfo: result
          })
        })
    }
    this.setState({
      userTopId: data.value
    })
  }

  render() {
    let {isLoading, availableRollItems, pickedRollItems, userTopInfo, userTopId} = this.state
    return (
      <div>
        <MarqueeBanner/>
        <div className="container store">
          <Segment loading={isLoading} style={{border: 'none', paddingBottom: '70px'}}>
            <InfoTab/>
            <Divider horizontal={true}/>

            <Grid columns="2" stackable={true} style={{border: 'none'}}>
              <Grid.Column>
                <Header as="h3" attached="top">
                  Chọn Item
                  <Button
                    floated={'right'}
                    size={'mini'}
                    color={'blue'}
                    onClick={this.getAvailableItem}
                  >
                    <Icon name="refresh"/>Tải lại
                  </Button>
                </Header>
                <GameItemDeck items={availableRollItems} onClickItem={this.handlePickItem}/>
              </Grid.Column>
              <Grid.Column>
                <Header as="h3" attached="top">
                  Tổng giá
                  trị: {common.calculatePickedValue(pickedRollItems)} ~
                  {common.calculatePickedVnd(pickedRollItems).toLocaleString('vn') + 'vnd'}
                </Header>
                <Input
                  className={'inline'}
                  required={true}
                  label={'SteamID/DigitalID'}
                  onChange={this.onChangeSteamId}
                  value={userTopId}
                />
                <h6>{userTopInfo.nickname ? userTopInfo.nickname : 'Không tìm thấy user'}</h6>

                <GameItemDeck items={pickedRollItems} onClickItem={this.handleRemoveItem} isCart={true}/>
                <Button color={'blue'} onClick={this.onClickBuyItem}>Mua</Button>
                <Divider/>
              </Grid.Column>
            </Grid>
          </Segment>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/RollItemStore/RollItemStoreAdmin.tsx